// custom events to use with MapBox
enum CustomMapEvents {
  LAYER_VISIBILITY_CHANGE = 'layer-visibility-change',
  GROUP_LAYER_CHANGE = 'group-layer-change',
}

export default CustomMapEvents;
